<template>
  <div class="inventory-misc-charges-table">
    <table class="table table-sm w-100 mb-0">
      <tr>
        <th class="border-top-0">{{ $t('Title') }}</th>
        <th class="border-top-0">{{ $t('Comment') }}</th>
        <th class="border-top-0">{{ $t('Amount') }}</th>
        <th class="border-top-0">{{ $t('Percentage') }}</th>
        <th class="border-top-0">{{ $t('Taxable') }}</th>
        <th class="border-top-0"></th>
      </tr>
      <tr v-for="item in miscItems" :key="item.uuid">
        <td>{{ item.description }}</td>
        <td>{{ item.comment }}</td>
        <td>
          <span v-if="item.amount">{{ item.amount | asCurrency }}</span>
        </td>
        <td>
          <span v-if="item.percentage">{{ item.percentage | asPercentage }}</span>
        </td>
        <td>
          <span class="badge badge-success" v-if="item.taxable">{{ $t("Yes") }}</span>
          <span class="badge badge-danger" v-else>{{ $t("No") }}</span>
        </td>
        <td>
          <b-button v-permission="'change_customer'" class="float-right p-0 visible-on-touch text-danger ml-2" variant="link"
                    @click="onDeleteClick(item)">
            <font-awesome-icon :icon="'trash'" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Delete') }}
          </b-button>
          <b-button v-permission="'change_customer'" class="float-right p-0 visible-on-touch " variant="link"
                    @click="onEditClick(item)">
            <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Edit') }}
          </b-button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import {SOURCE_INVENTORY_DASHBOARD} from "@/modules/constants";

  const {mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryMiscChargesTable",
    props: {
      miscItems: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      ...mapActions(['showInventoryMiscChargeModal', 'deleteInventoryMiscCharge']),
      onEditClick(item) {
        this.showInventoryMiscChargeModal({
          source: SOURCE_INVENTORY_DASHBOARD,
          object: item
        })
      },
      onDeleteClick(item) {
        this.$confirm(
            this.$i18n.t("Are you sure you want to delete following invoice miscellaneous charge?"),
            this.$i18n.t('Invoice miscellaneous charge was successfully deleted'),
            this.deleteInventoryMiscCharge,
            item
        );
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../../scss/variables";

  .inventory-misc-charges-table {

    button {
      visibility: hidden;
    }

    tr:hover {
      button {
        visibility: visible;
      }

      td {
        background-color: lighten($secondary, 6);
      }
    }
  }
</style>
